import { IVisualization } from "../IVisualization";
import { IServiceResult, ITableauView } from "../../Models/Models";
import axios from "axios";

export class VisualizationAxios implements IVisualization {
    public GetViews(): Promise<IServiceResult<ITableauView[]>> {
        const promise = new Promise<IServiceResult<ITableauView[]>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<ITableauView[]>>(
                        "/Visualization/TableauViews",
                        {}
                    )
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }
}
